module.exports = __webpack_public_path__ + "static/media/container13.c950d696.jpg";